export default "__VITE_ASSET__DglMdpET__"